import queryString from 'query-string';
import storage from '../lib/storage';
import {http} from '../lib/http/request';
import toast from "react-hot-toast";

/**
 * Save a project JSON to the project server.
 * This should eventually live in scratch-www.
 * @param {number} projectId the ID of the project, null if a new project.
 * @param {object} vmState the JSON project representation.
 * @param {object} params the request params.
 * @property {?number} params.originalId the original project ID if a copy/remix.
 * @property {?boolean} params.isCopy a flag indicating if this save is creating a copy.
 * @property {?boolean} params.isRemix a flag indicating if this save is creating a remix.
 * @property {?string} params.title the title of the project.
 * @return {Promise} A promise that resolves when the network request resolves.
 */
export default function (projectId, vmState, params) {
    console.log(params)
    const creatingProject = projectId === null || typeof projectId === 'undefined';
    const queryParams = {};
    if (Object.prototype.hasOwnProperty.call(params, 'originalId')) queryParams.original_id = params.originalId;
    if (Object.prototype.hasOwnProperty.call(params, 'isCopy')) queryParams.is_copy = params.isCopy;
    if (Object.prototype.hasOwnProperty.call(params, 'isRemix')) queryParams.is_remix = params.isRemix;
    if (Object.prototype.hasOwnProperty.call(params, 'title')) queryParams.title = params.title;
    let qs = queryString.stringify(queryParams);
    if (qs) qs = `?${qs}`;
    const projectHost = `${storage.projectHost}/${http.contextPath}/scratchProject/timedSave`;
    const url = creatingProject ?
        `${projectHost}${qs}` :
        `${projectHost}/${projectId}${qs}`;
    const method = creatingProject ? 'POST' : 'PUT';

    return http.request(url, method, vmState, {rawBody: true})
        .then(body => {
            console.log(body)
            if (Object.prototype.hasOwnProperty.call(body, 'success') && body.success){
                toast.success(body.message)
                return body.result
            }
            toast.error(body.message)
            body.result.id = projectId
            return body.result;
        });
}
